import type {SlotWidgetConfig} from '../types'
import {WidgetType} from '../types'

export function isRadio(props: SlotWidgetConfig): boolean {
  // Если в хвосте слота есть радиобаттон, делаем весь слот кликабельным
  const type = props.slot.trail1?.type || props.slot.trail2?.type

  return type === WidgetType.RADIO || Boolean(props.slot.action)
}

export function isHeader(props: SlotWidgetConfig): boolean {
  return Boolean(props.accessibility_info?.is_header)
}

export function isBusinessOfferMock(props: SlotWidgetConfig): boolean {
  return props.widget_id
    ? props.widget_id.includes('cargo_c2c_order_forms_b2b_lk_cargo_offer_payment_mock_slot_widget')
    : false
}

export function isBusinessPlate(props: SlotWidgetConfig): boolean {
  return props.widget_id
    ? props.widget_id.includes('cargo_c2c_order_forms_b2b_lk_cargo_business_banner_information_slot_widget')
    : false
}

export function isSummarization(props: SlotWidgetConfig): boolean {
  return props.widget_id
    ? props.widget_id.includes('cargo_c2c_order_forms_b2b_lk_summarization_information_slot_widget')
    : false
}

export const isInformation = (props: SlotWidgetConfig): boolean => {
  return props.widget_id
    ? props.widget_id.includes('cargo_c2c_order_forms_b2b_lk_specify_addresses_information_slot_widget')
    : false
}
